import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const singleProductHeader = () => {
  const container = document.querySelector('.single-product__header');

  if (!container) return;

  const isFixedHeader = container.classList.contains('fixed-header-block');
  const dontTranslateTitle = container.classList.contains('no-translate-title');

  if (!isFixedHeader) return;

  const mdBreakpoint = 768;
  const match = window.matchMedia(`(min-width: ${mdBreakpoint}px)`);

  const title = container.querySelector('.single-product__header__title');
  const checkList = container.querySelector('.single-product__header__checklist');
  const icon = container.querySelector('.single-product__header__icon');
  const backArrow = container.querySelector('.single-product__header__title__back-arrow');

  const ease = 'power0';
  const duration = 3;
  const fontSize = '1.125rem';

  gsap.set(container, {zIndex: 20});
  const timeline1 = gsap.timeline({
    scrollTrigger: {
      trigger: 'main',
      pin: container,
      anticipatePin: true,
      pinSpacing: false,
      start: "top top",
      end: 99999999,
    },
  });

  const timeline = gsap.timeline({
    lazy: true,
    scrollTrigger: {
      end: 'bottom top+=200px',
      scrub: 1,
      start: 'top top',
      trigger: container
    }
  });

  ['lotties-refreshed'].forEach(eventName => {
    document.addEventListener(eventName, () => {
      timeline1.scrollTrigger.refresh();
      timeline.scrollTrigger.refresh();
    });
  });

  const desktopAnimation = () => {
    timeline.to(
      container,
      {
        duration,
        ease,
        height: 50,
        padding: 0
      },
      0
    );

    timeline.to(
      backArrow,
      {
        duration,
        ease,
        opacity: 1,
        x: 0,
      },
      0
    );

    timeline.to(
      title,
      {
        duration,
        ease,
        fontSize,
        margin: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        paddingLeft: dontTranslateTitle ? undefined : '2rem',
      },
      0
    );

    timeline.to(
      checkList,
      {
        duration,
        ease,
        height: 0,
        opacity: 0,
        padding: 0,
        y: '100%',
        margin: 0
      },
      0
    );

    timeline.to(
      icon,
      {
        duration,
        ease,
        height: 0,
        opacity: 0,
        padding: 0
      },
      0
    );
  };

  const mobileAnimation = () => {
    timeline.to(
      container,
      {
        duration,
        ease,
        height: 50,
      },
      0
    );

    timeline.to(
      backArrow,
      {
        duration,
        ease,
        opacity: 1,
        x: 0,
      },
      0
    );

    timeline.to(
      title,
      {
        duration,
        ease,
        fontSize,
        margin: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: 0,
        paddingLeft: '2rem',
      },
      0
    );

    timeline.to(
      checkList,
      {
        duration,
        ease,
        height: 0,
        margin: 0,
        opacity: 0,
        padding: 0,
        x: '-200%'
      },
      0
    );

    timeline.to(
      icon,
      {
        duration,
        ease,
        height: 0,
        opacity: 0,
        padding: 0,
        x: '200%'
      },
      0
    );
  };

  ScrollTrigger.matchMedia({
    [`(min-width: 0px) and (max-width: ${mdBreakpoint - 1}px)`]: mobileAnimation,
    [`(min-width: ${mdBreakpoint}px)`]: desktopAnimation
  });

  match.onchange = () => {
    ScrollTrigger.refresh();
  }
};

document.addEventListener("DOMContentLoaded", function() {
  singleProductHeader()
});
